module.exports = __webpack_public_path__ + "static/media/SW200.aa7d055e.pdf";